export default "__VITE_ASSET__Bi9I$ZOi__"